import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["option", "__children"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { NavItemEnum, SegmentedNavItems } from '../../constants/routing/NavItems';
import { usePageParams } from '../../hooks/usePageParams';
import { isUngatedForMarketingPlusSelector } from '../../selectors/GatingSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const OptionComponent = _ref => {
  let {
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: option.text
    })
  }));
};
const MobileDropdownNavLabel = styled(UIFormControl).withConfig({
  displayName: "MobileDropdownNav__MobileDropdownNavLabel",
  componentId: "sc-7iy5u3-0"
})(["width:94%;margin:0 auto;"]);
const MobileDropdownNav = ({
  selectedNavItem
}) => {
  const history = useHistory();
  const {
    tab
  } = usePageParams();
  const [currNavItem, selectCurrNavItem] = useState(selectedNavItem);
  const isUngatedToMarketingPlus = useSelector(isUngatedForMarketingPlusSelector);
  const navItems = SegmentedNavItems;
  const shouldHideNavItem = item => {
    return item === NavItemEnum.MARKETING_PLUS && !isUngatedToMarketingPlus || item === NavItemEnum.ADD_ONS // not available on mobile or public
    ;
  };
  const navItemOptions = Object.values(navItems).flat().filter(navItem => !shouldHideNavItem(navItem)).map(navItem => {
    return {
      text: `pricingPage.pages.products.tabs.${navItem}.tabTitle`,
      value: navItem
    };
  });
  const hasTabs = navItem => {
    return NavItemEnum.BUNDLE !== navItem && NavItemEnum.FREE !== navItem && NavItemEnum.COMMERCE !== navItem && NavItemEnum.MARKETING_PLUS !== navItem && NavItemEnum.ADD_ONS !== navItem;
  };
  const handleChange = evt => {
    evt.preventDefault();
    const newNavItem = evt.currentTarget.value;
    const toValue = `/${newNavItem}${tab && hasTabs(newNavItem) ? `/${tab}` : ''}`;
    selectCurrNavItem(newNavItem);
    history.push(toValue);
  };
  return /*#__PURE__*/_jsx(MobileDropdownNavLabel, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.tabs.pricingAndPlans"
    }),
    children: /*#__PURE__*/_jsx(UISelect, {
      searchable: false,
      itemComponent: OptionComponent,
      options: navItemOptions,
      onChange: handleChange,
      value: currNavItem
    })
  });
};
export default MobileDropdownNav;